exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.el-step__main .el-step__description {\n  padding-bottom: 10px;\n}\n.logistics-iframe{width: 100%;height: 500px;margin-bottom: 20px;\n}\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/components/logistics/viewLogistics.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;CACtB;AACD,kBAAkB,YAAY,cAAc,oBAAoB;CAC/D","file":"viewLogistics.vue","sourcesContent":["\n.el-step__main .el-step__description {\n  padding-bottom: 10px;\n}\n.logistics-iframe{width: 100%;height: 500px;margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ed766150","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/logistics/viewLogistics.vue
// module id = Aq5g
// module chunks = 0